export const FETCH_PAYMENT_GATEWAY_REQUEST = "FETCH_PAYMENT_GATEWAY_REQUEST";
